import { ref, getDownloadURL, listAll } from "firebase/storage";
import { storage } from "../firebase/config";

const SESSION_KEY_PREFIX = "music-folder-cache:";
const memoryCache = new Map();
const inflightRequests = new Map();

const readSessionCache = (screenKey) => {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.sessionStorage.getItem(`${SESSION_KEY_PREFIX}${screenKey}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch (_error) {
    return null;
  }
};

const writeSessionCache = (screenKey, urls) => {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(
      `${SESSION_KEY_PREFIX}${screenKey}`,
      JSON.stringify(urls),
    );
  } catch (_error) {
    // Ignore storage quota errors; memory cache will still help.
  }
};

export const MUSIC_FOLDERS = {
  dashboard: "soundtracks/dashboard",
  gameboard: "soundtracks/gameboard",
  lobby: "soundtracks/lobby",
  mycards: "soundtracks/mycards",
  test: "soundtracks/test",
};

export const loadMusicFolderUrls = async (screenKey) => {
  if (!screenKey || !MUSIC_FOLDERS[screenKey]) return [];

  if (memoryCache.has(screenKey)) {
    return memoryCache.get(screenKey);
  }

  const sessionCached = readSessionCache(screenKey);
  if (sessionCached) {
    memoryCache.set(screenKey, sessionCached);
    return sessionCached;
  }

  if (inflightRequests.has(screenKey)) {
    return inflightRequests.get(screenKey);
  }

  const request = (async () => {
    const folderRef = ref(storage, MUSIC_FOLDERS[screenKey]);
    const list = await listAll(folderRef);
    const urls = await Promise.all(
      list.items.map((itemRef) => getDownloadURL(itemRef)),
    );

    memoryCache.set(screenKey, urls);
    writeSessionCache(screenKey, urls);
    return urls;
  })();

  inflightRequests.set(screenKey, request);

  request.finally(() => {
    inflightRequests.delete(screenKey);
  });

  return request;
};
